<div class="sare-beneficially-hold">
  @if (isBeneficialOwner) {
    <span class="green">Yes</span>
  } @else if (beneficialOwner) {
    <span>{{ beneficialOwner }}</span>
  } @else {
    <span class="purple">No</span>
  }
</div>
